export default "__VITE_ASSET__e7e29410__"